"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var capitalRecordApi = _interopRequireWildcard(require("@/api/capitalRecordApi.js"));
var _addRecord = _interopRequireDefault(require("./addRecord.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    AddRecord: _addRecord.default
  },
  props: {
    fromType: [Number, String]
  },
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      constants: this.$constants,
      typeOpetion: [{
        value: 1,
        name: '充值'
      }, {
        value: -1,
        name: '扣费'
      }],
      listPram: {
        keywords: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      editDialogConfig: {
        visible: false,
        editId: 0
      },
      detailDialogConfig: {
        visible: false,
        editId: 0
      },
      detailMap: [{
        title: '变更类型',
        dataIndex: 'fundType'
      }, {
        title: '日志',
        dataIndex: 'detail'
      }, {
        title: '关联账户',
        dataIndex: 'relatedAccount'
      }, {
        title: '记录凭证',
        dataIndex: 'recordProofUrl'
      }, {
        title: '备注',
        dataIndex: 'remark'
      }, {
        title: '操作时间',
        dataIndex: 'updateTime'
      }],
      recordDetail: {},
      initDetail: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    // 打开
    initOpen: function initOpen(row) {
      this.initDetail = row || {};
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      capitalRecordApi.ListArticle(_objectSpread(_objectSpread({}, pram), {}, {
        supplierId: this.initDetail.id
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 获取详情
    handlerOpenSetting: function handlerOpenSetting(editId) {
      var _this2 = this;
      this.recordDetail = {};
      capitalRecordApi.getComDetail(editId).then(function (res) {
        _this2.recordDetail = res || {};
        _this2.detailDialogConfig.visible = true;
      });
    },
    handlerOpenEdit: function handlerOpenEdit() {
      this.editDialogConfig.visible = true;
    },
    handlerHideDialog: function handlerHideDialog() {
      var isRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (isRefresh == 1) {
        // 是否刷新列表
        this.handlerGetListData(_objectSpread({}, this.listPram));
      }
      ;
      this.editDialogConfig.visible = false;
      this.detailDialogConfig.visible = false;
    }
  }
};